import { formatLocaleNumber } from '@search/helpers/src/formatNumber';

export const defaultBanksTotal = 22;
export const defaultMortgageRateNb = 4.5;
export const defaultMortgageRateSecond = 13;

export const defaultMortgageRateNbFormatted = formatLocaleNumber(defaultMortgageRateNb);
export const defaultMortgageRateSecondFormatted = formatLocaleNumber(defaultMortgageRateSecond);
